import { Formik, ErrorMessage, Field, Form } from 'formik';
import { registerInitial, registerSchema } from '../../validations/authValidations';
import { useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { closeModal } from '../../stores/slices/commonSlice';
import { registerAction } from '../../stores/actions/authActions';
import { useDispatch } from 'react-redux';
import { ArrowRight } from 'lucide-react';

const INPUT_CLASS =
  'w-full h-12 px-4 rounded-xl border border-gray-200 bg-white text-sm font-medium text-gray-900 placeholder:text-gray-400 outline-none transition-colors focus:border-gray-300 focus:ring-0 shadow-none';
const LABEL_CLASS = 'text-sm font-bold text-gray-700 mb-1.5 block';
const ERROR_CLASS = 'text-red-500 text-xs mt-1.5 mb-0';

export default function RegisterComponent() {
  const [signUpBtn, setSignUpBtn] = useState('SIGN UP');
  const [disabled, setDisabled] = useState(false);
  const [captchaError, setCaptchaError] = useState();
  const captchaRef = useRef(null);
  const dispatch = useDispatch();

  const signUp = async (values) => {
    const captchaValue = captchaRef.current.getValue();
    if (!captchaValue) {
      setCaptchaError('Please complete the reCAPTCHA');
      return;
    }
    setCaptchaError('');
    setDisabled(true);
    setSignUpBtn('Please wait ....');

    dispatch(registerAction(values)).then((response) => {
      if (response.meta.requestStatus === 'fulfilled') {
        setDisabled(false);
        setSignUpBtn('SIGN UP');
        dispatch(closeModal());
      } else {
        setDisabled(false);
        setSignUpBtn('SIGN UP');
      }
    });
    captchaRef.current.reset();
  };

  return (
    <Formik
      initialValues={registerInitial}
      validationSchema={registerSchema}
      onSubmit={(values) => {
        signUp(values);
      }}
    >
      <Form className="flex flex-col gap-3">
        <div>
          <label htmlFor="username" className={LABEL_CLASS}>
            Username
          </label>
          <Field type="text" name="username" placeholder="Choose A Username" id="username" className={INPUT_CLASS} />
          <ErrorMessage name="username" component="p" className={ERROR_CLASS} />
        </div>

        <div>
          <label htmlFor="email" className={LABEL_CLASS}>
            Email
          </label>
          <Field type="email" name="email" placeholder="Enter Your Email Address" id="email" className={INPUT_CLASS} />
          <ErrorMessage name="email" component="p" className={ERROR_CLASS} />
        </div>

        <div>
          <label htmlFor="password" className={LABEL_CLASS}>
            Password
          </label>
          <Field type="password" name="password" placeholder="Create A Passoword "  id="password" className={INPUT_CLASS} />
          <ErrorMessage name="password" component="p" className={ERROR_CLASS} />
        </div>

        <div>
          <ReCAPTCHA sitekey="6Lfhg6glAAAAAB0Bh7n3xE8K14ikhNIItMJzSBAc" ref={captchaRef} />
          {captchaError && <p className={ERROR_CLASS}>{captchaError}</p>}
        </div>

        <button
          disabled={disabled}
          type="submit"
          className="flex h-12 w-full items-center justify-center gap-2 rounded-xl border-none bg-[#ffea00] text-sm font-bold text-gray-900 shadow-[0_2px_10px_rgba(255,234,0,0.35)] transition-all hover:bg-[#e6d300] hover:shadow-[0_4px_14px_rgba(255,234,0,0.45)] disabled:cursor-not-allowed disabled:opacity-60"
        >
          {signUpBtn}
          {signUpBtn === 'SIGN UP' && <ArrowRight size={16} strokeWidth={2.5} />}
        </button>
      </Form>
    </Formik>
  );
}
